import api from '@/libs/axios'
import { PaginatedList } from '../models/common/paginatedList'
import { SecteurActivite } from '../models/options/secteursActivites/secteurActivite';

const resource = 'SecteursActivites'

export default class SecteursActivitesResource {
  public async paginatedList(pagenumber?: number, pagesize?: number, search?: string) : Promise<PaginatedList<SecteurActivite>> {
    const params = new URLSearchParams();
    if (pagenumber) params.append('PageNumber', pagenumber.toString()); 
    if (pagesize) params.append('PageSize', pagesize.toString()); 
    if (search && search.length) params.append('Search', search?.toString()); 

    const response = await api.get(`${resource}`, { params: params } )
    return response.data
  }
}
